function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.892 38.1108H4.31934C3.40967 38.1108 2.5 37.2011 2.5 36.2915V8.81934C2.5 7.90967 3.40967 7 4.31934 7H46.892C47.8017 7 48.7113 7.90967 48.7113 8.81934V36.2915C48.7113 37.3831 47.9836 38.1108 46.892 38.1108Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.5282 9.91113H5.04712V35.0181H46.5282V9.91113Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6057 8.81951C25.8066 8.81951 25.9695 8.65663 25.9695 8.45567C25.9695 8.25471 25.8066 8.09178 25.6057 8.09178C25.4047 8.09178 25.2418 8.25471 25.2418 8.45567C25.2418 8.65663 25.4047 8.81951 25.6057 8.81951Z",
  fill: "#172B4D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3399 46.48H14.8716C14.3258 46.48 13.962 46.1161 13.962 45.5703V44.4787C13.962 43.9329 14.3258 43.569 14.8716 43.569H36.3399C36.8857 43.569 37.2496 43.9329 37.2496 44.4787V45.5703C37.2496 46.1161 36.8857 46.48 36.3399 46.48Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M30.6999 38.111H20.6936C20.6936 41.9316 18.5103 43.569 18.5103 43.569H32.8831C32.8831 43.569 30.6999 42.1135 30.6999 38.111Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.77612 31.7434L16.327 23.5563L18.3283 25.9214L22.3309 21.737L25.4237 25.1937L29.6083 20.6453L32.1553 23.3744L41.434 13.7319",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M7.77612 31.7435L16.327 23.5564L18.3283 25.9215L22.3309 21.7371L25.4237 25.1938L29.6083 20.6454L32.1553 23.3745L37.0676 18.2803",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M41.4339 13.7319L37.7953 22.8287L36.7036 18.6441L32.5192 17.7345L41.4339 13.7319Z",
  fill: "#172B4D"
});

var SvgReports = function SvgReports(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Reports.2c42025d.svg";
export { ForwardRef as ReactComponent };